import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-work-landing',
  templateUrl: './work-landing.component.html',
  styleUrls: ['./work-landing.component.css']
})
export class WorkLandingComponent implements OnInit {

  // https://codepen.io/Sicontis/pen/VwjVdYz
  constructor() { }

  ngOnInit(): void {
  }

}
